import React from 'react';

/**
 * A simple, visually distinct loading spinner component.
 * It uses Tailwind CSS to create a white-on-gray spinning circle.
 */
export default function Spinner() {
    return (
        <div 
            className="w-12 h-12 border-4 border-t-4 border-gray-400 border-t-white rounded-full animate-spin z-[10000]"
            aria-label="Loading content"
            role="status"
        >
            {/* The spinner animation is handled purely by the Tailwind classes:
                - w-12 h-12: Defines size.
                - border-4: Defines border thickness.
                - border-gray-400: Sets the main border color (the background of the circle).
                - border-t-white: Sets the top border color (the moving part).
                - rounded-full: Makes it a circle.
                - animate-spin: Applies the CSS rotation animation.
            */}
        </div>
    );
}